<script>
  import { ignore, getCollapseClass } from "../../Common/tools";
  import Slider from "../../Common/Slider.svelte";
  import BlockGlobal from "./BlockGlobal.svelte";
  import {M} from "../../external";

  export let data,
    onChange = ignore,
    disable = [],
    label = "Image",
    isCollapsable = false,
    isCollapsed = false;

  function toggleCollapse() {
    if (isCollapsable) {
      isCollapsed = !isCollapsed;
    }
  }
</script>

<div class="col20 f-left t-center mb-25 mt-15" on:click={toggleCollapse}><h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{label}</h4></div>
{#if !isCollapsed}
  <div class="section">
    {#if disable.indexOf("width") === -1}
      <Slider
        min={10}
        max={500}
        value={data.style.width || "139"}
        clz="mt-5"
        showValue={false}
        sameLine={true}
        onChange={(val) => onChange("width", val)}
        label={M.IMAGE_WIDTH} />
    {/if}
    {#if disable.indexOf("align") === -1}
      <div class="popup-input-wrapper input-slider-wrapper mt-5">
        <h5 class="inline">Image Align</h5>
        <select bind:value={data.style.position}>
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </div>
    {/if}
  </div>
{/if}
<BlockGlobal bind:data disable={disable} isCollapsable={true} isCollapsed={true} />
